import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../components/common/CommonButton";
import translations from "../../components/common/Translations";
import AppConext from '../../context/AppContext'
export default function DesktopTabletOnly({ children, breakpoint = 768 }) {
  const [isBlocked, setIsBlocked] = useState(false);
  const { langMode } = useContext(AppConext)
  const navigate = useNavigate();

  useEffect(() => {
    const checkSize = () => setIsBlocked(window.innerWidth < breakpoint);
    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, [breakpoint]);

  if (!isBlocked) return <>{children}</>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 max-w-sm w-full text-center">
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
          {translations[langMode].workflowmodule}
        </p>
        <CommonButton colorIntent="primary"
          variant="primary"
          tooltipText={translations[langMode].requestreporbasedonfilter}
          tooltipPosition="top"
          onClick={() => navigate(-1)}
        >
         {translations[langMode].goback}
        </CommonButton>
      </div>
    </div>
  );
}
